module.exports = __webpack_public_path__ + "img/bubble_correct.b7a1deae.svg";